import styled from 'styled-components';
import { Box, Card, ListItem } from '@mui/material';

export const Container = styled(Box)`
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  overflow: visible;
`;

export const PricingHeader = styled(Box)`
  text-align: center;
  margin-bottom: 32px;
`;

export const ToggleContainer = styled(Box)`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

export const PlansContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 24px;
  max-width: 1000px;
  margin: 0 auto;
  padding-top: 20px;
  overflow: visible;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const PlanCard = styled(Card)`
  position: relative;
  padding: 24px;
  padding-top: ${({ popular }) => (popular ? '36px' : '24px')};
  height: fit-content;
  display: flex;
  flex-direction: column;
  border: 2px solid
    ${({ popular }) => (popular ? '#1976d2' : 'rgba(0, 0, 0, 0.12)')};
  transition: all 0.3s ease;
  margin-top: 0px;
  overflow: visible;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.15);
  }
`;

export const PopularBadge = styled(Box)`
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
  background: #1976d2;
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  z-index: 10;
`;

export const PlanHeader = styled(Box)`
  text-align: center;
  margin-bottom: 16px;
`;

export const PlanPrice = styled(Box)`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PlanFeatures = styled(Box)`
  flex-grow: 1;
  margin: 16px 0;
`;

export const FeatureItem = styled(ListItem)`
  padding: 4px 0;
  opacity: ${({ included }) => (included ? 1 : 0.6)};
`;

export const PlanButton = styled(Box)`
  margin-top: 24px;
`;
